import { gridSize } from "@/shared";
import {
  FormControl,
  Grid,
  MenuItem,
  TextField,
  TextFieldProps,
} from "@mui/material";
import { FieldError } from "react-hook-form";

export type PortsSelectProps = {
  label?: string;
  required?: boolean;

  register: TextFieldProps;
  defaultValue: string | number | boolean;
  textFieldKey?: string | number | boolean;
  error?: FieldError;
  helperText?: React.ReactNode;

  size?: {
    xs: number;
    sm: number;
    md: number;
    lg: number;
  };

  disabled?: boolean;
};

const PortsSelect: React.FC<PortsSelectProps> = ({
  error,
  textFieldKey,
  defaultValue,
  helperText,
  label = "Puertos",
  register,
  size = gridSize,
  required = false,
  disabled = false,
}) => {
  return (
    <Grid item {...size}>
      <FormControl fullWidth variant="outlined">
        <TextField
          key={(textFieldKey || defaultValue) as any}
          select
          label={label}
          variant="outlined"
          fullWidth
          defaultValue={defaultValue}
          {...register}
          error={!!error}
          helperText={helperText}
          required={required}
          disabled={disabled}
        >
          <MenuItem value={"8"}>8</MenuItem>
          <MenuItem value={"16"}>16</MenuItem>
        </TextField>
      </FormControl>
    </Grid>
  );
};

export default PortsSelect;
